<div class="container-fluid bg-white entity">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div class="page" *ngIf="!isLoading()">

    <div class="page-body">

      <div class="container-section">

        <div class="container-smaller">

          <div class="content-wrapper">

            <div class="content">

              <div class="entity-single">

                <div class="row">

                  <div class="col-12 col-sm-12 column-left text-center">

                    <h1 class="page-title entity-title alternate-heading">
                      {{getTranslatedTitle(entity)}}
                    </h1>

                    <span class="entity-content" [innerHTML]="getTranslatedContent(entity) | safeHtml"></span>


                  </div>

                  <div class="col-12 column-right text-center">

                    <div class="image-main text-center entity-image-main cursor-pointer" (click)="videoService.openVideo(entity.videoUri)">
                      <img class="img-fluid m-auto" [src]="videoService.getYoutubeThumbnail(entity.videoUri)" />
                    </div>

                  </div>

                </div>

              </div>

              <!-- testimonials -->
              <div class="section section-testimonials bg-white">

                <div class="container-fluid">

                  <div class="container-section">

                    <div class="row">
                      <div class="col-12 text-center">

                        <img class="testimonial-quote" src="assets/img/testimonial-quote.png">

                        <div class="slider-testimonials">
                          <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" *ngIf="testimonialSlides().length > 0">
                            <ng-template *ngFor="let slide of testimonialSlides()" ngbSlide>

                              <div class="row">

                                <div class="col-12">
                                  <div class="item-wrapper">

                                    <h4 *ngIf="slide.testimonialName" class="item-subtitle">{{slide.testimonialName}}</h4>

                                  </div>
                                </div>

                              </div>

                            </ng-template>
                          </ngb-carousel>
                        </div>

                      </div>
                    </div>

                  </div>

                </div>

              </div>

              <div class="entity-related mt-4">

                <h3 class="alternate-heading text-center mb-4">
                  <span class="text-primary">{{'More' | translate}}</span> {{'videos' | translate}}
                </h3>

                <div class="grid grid-video">

                  <div class="row">

                    <div class="col-6 col-sm-4 grid-item grid-item-video" *ngFor="let node of relatedData()">

                      <a class="grid-item-link" [routerLink]="'/videos/' + (node.permalink ? node.permalink : node.id)">

                        <div class="grid-item-image-wrapper" *ngIf="videoService.getYoutubeThumbnail(node.videoUri)">
                          <img class="grid-item-image grid-item-image-video img-fluid" [src]="videoService.getYoutubeThumbnail(node.videoUri)" />
                        </div>

                        <h3 class="grid-item-title">
                          {{getTranslatedTitle(node)}}
                        </h3>
                      </a>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
